
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Създаване на Механизация</h5>
        <p class="text-center small">Моля, въведете основните данни на Механизацията</p>
      </div>


      <div>

        <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
          <div class="col-12">
            <label for="title" class="form-label">Име</label>
            <input type="text" formControlName="title" class="form-control" id="title">
          </div>
          <div class="col-12">
            <label for="description" class="form-label">Кратко Описание</label>
            <input type="text" formControlName="description" class="form-control" id="description">
          </div>  
          <div class="col-12">
            <label for="totalQuantity" class="form-label">Обща Бройка</label>
            <input type="text" formControlName="totalQuantity" class="form-control" id="totalQuantity">
          </div>         
          <div class="col-12">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
              <label class="form-check-label" for="isActive">Активна</label>
            </div>
          </div>
          <div class="col-12">
            <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Създай</button>
          </div>
        </form>
      </div>

    </div>
  </div>

</ng-container>
